import React from "react";
import { ShieldCheck, Settings2, Heart } from "lucide-react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1632823471565-1ecdf5c6da77?auto=format&fit=crop&w=1600&q=80";

export default function About() {
  return (
    <section
      id="rolunk"
      className="relative py-24 sm:py-32 border-t border-white/5"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <span className="section-eyebrow mb-4">03 / Rólunk</span>
          <h2
            className="mt-5 font-black uppercase tracking-tight text-white leading-[0.95]"
            style={{
              fontFamily: "Barlow Condensed",
              fontSize: "clamp(2.25rem, 5vw, 4rem)",
            }}
          >
            Mert az <span className="text-[#0082D2]">autó</span>
            <br />
            a szerelmünk.
          </h2>

          <p className="mt-8 text-zinc-300 leading-relaxed">
            A Séra Autószervíz – Autó-Szerelem néven egy debreceni műhely,
            ahol minden ügyfelet úgy szolgálunk ki, mintha a saját autónk
            lenne a hídon. Q-Service hálózati tagként márkafüggetlenül
            javítunk, MotulEVO automataváltó-olajcserét végzünk, és külön
            szenvedéllyel foglalkozunk a BMW-kel.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            <Feature
              icon={ShieldCheck}
              title="Q-Service tagság"
              text="Garantált minőség és átláthatóság."
            />
            <Feature
              icon={Settings2}
              title="MotulEVO technológia"
              text="Csúcsminőségű váltóolaj-csere."
            />
            <Feature
              icon={Heart}
              title="Szenvedéllyel"
              text="Minden szerelőnk autórajongó."
            />
          </div>
        </div>

        <div className="lg:col-span-6 relative">
          <div className="relative">
            <img
              src={ABOUT_IMG}
              alt="Modern autószervíz műhely"
              className="w-full aspect-[4/5] object-cover grayscale-[15%]"
            />
            <div className="absolute -bottom-6 -left-6 m-stripe h-2 w-40" />
            <div className="absolute -top-6 -right-6 hidden md:block">
              <div className="bg-[#0082D2] text-white px-6 py-4">
                <div
                  className="text-3xl font-black uppercase leading-none"
                  style={{ fontFamily: "Barlow Condensed" }}
                >
                  Debrecen
                </div>
                <div className="text-[0.65rem] uppercase tracking-[0.2em] mt-1">
                  Q-Service tag
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Feature({ icon: Icon, title, text }) {
  return (
    <div>
      <Icon className="w-6 h-6 text-[#0082D2] mb-3" strokeWidth={1.5} />
      <div
        className="text-base font-bold uppercase text-white tracking-tight"
        style={{ fontFamily: "Barlow Condensed" }}
      >
        {title}
      </div>
      <div className="text-sm text-zinc-400 mt-1">{text}</div>
    </div>
  );
}
